import {
  Module,
  Mutation,
  getModule,
  Action,
  VuexModule
} from "vuex-module-decorators";
import { Vue } from "vue-property-decorator";
import { store } from "@/store";

export enum MessageKeys {
  Default
}

export type Message = {
  message: string;
  timeout?: number;
};

@Module({
  dynamic: true,
  store,
  name: "Messages",
  namespaced: true
})
class Messages extends VuexModule implements Messages {
  isDisplayed = false;
  message = "";
  messageTimeoutDefault = 7000;
  messageTimeout = this.messageTimeoutDefault;

  protected readonly messageStrings: Record<MessageKeys, string> = {
    [MessageKeys.Default]: "Some error" //This string was created just for example.
  };
  @Mutation
  private CHANGE_MESSAGE(message: string): void {
    this.message = message;
  }

  @Mutation
  private SHOW_MESSAGE(): void {
    this.isDisplayed = true;
  }

  @Mutation
  private CHANGE_MESSAGE_TIMEOUT(messageTimeout: number): void {
    this.messageTimeout = messageTimeout;
  }

  @Mutation
  private HIDE_MESSAGE(): void {
    this.isDisplayed = false;
  }

  @Action({ rawError: true })
  public showMessage(message: Message): void {
    this.CHANGE_MESSAGE(message.message);
    this.CHANGE_MESSAGE_TIMEOUT(message.timeout || this.messageTimeoutDefault);
    this.SHOW_MESSAGE();
  }

  @Action({ rawError: true })
  public hideMessage(): void {
    this.HIDE_MESSAGE();
  }

  public getPreparedMessage(messageKey: MessageKeys): string {
    return this.messageStrings[messageKey];
  }
}

export const MessageModule = getModule(Messages);
